"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shortTermPower = void 0;
const shortTermPower = exports.shortTermPower = {
  POWER_SHORT_TERM_FORECAST: {
    en: {
      title: 'ICIS Short-Term Power',
      subtitle: 'An integrated view of rapidly evolving power markets',
      description: 'Stress test trading and investment strategies and balance risk with reliable short-term power forecasts, including wind and solar energy output.'
    },
    zh: {
      title: 'ICIS电力短期预测',
      subtitle: '综合纵览快速发展的电力市场',
      description: '通过可靠的短期电力预测（包括风能和太阳能输出），对交易和投资策略进行压力测试，并平衡风险。'
    }
  }
};